/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData model module.
 * @module model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData
     */
    constructor() { 
        
        EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData} The populated <code>EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData();

            if (data.hasOwnProperty('packLogNo')) {
                obj['packLogNo'] = ApiClient.convertToType(data['packLogNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('hadAt')) {
                obj['hadAt'] = ApiClient.convertToType(data['hadAt'], 'Date');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} packLogNo
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['packLogNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['email'] = undefined;

/**
 * @member {Date} hadAt
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['hadAt'] = undefined;

/**
 * @member {Number} postNo
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['postNo'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData;

